import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraTelefone,aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialPerfilAcessosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  perfilAcessoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const perfilAcessosSlice = createSlice({
  name: "perfilAcessos",
  initialState: initialPerfilAcessosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getPerfilAcessoById
    perfilAcessoFetched: (state, action) => {


      state.listLoading = false;
      // APLICAR A MASCARA
      state.perfilAcessoForEdit = action.payload.perfilAcessoForEdit;
      state.error = null;

    },
    // findPerfilAcessos
    perfilAcessosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createPerfilAcesso
    perfilAcessoCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities.push(action.payload.perfilAcesso);
    },
    // updatePerfilAcesso
    perfilAcessoUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.perfilAcesso.id) {
          return action.payload.perfilAcesso;
        }
        return entity;
      });
    },
    // deletePerfilAcesso
    perfilAcessoDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletePerfilAcessos
    perfilAcessosDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // perfilAcessosUpdateState
    perfilAcessosStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
